/*
 * BuroEcl
 * Copyright (c) 2023 Buroclic. All rights reserved.
 * 
 * This file corresponds to the MobileScreenProvider component
 * It is used in App.js in order to catch window resize and switch
 * between standard display and mobile one (which is more adapted to small electronic devices)
 */

import React, { createContext, useContext, useEffect, useState } from 'react';

const MobileScreenContext = createContext<Boolean>(false);

export const useIsMobileScreen = (): Boolean => useContext(MobileScreenContext);

export const MobileScreenProvider = ({ children }) => {
    const [isMobileScreen, setIsMobileScreen] = useState<boolean>(Math.min(window.innerWidth, window.outerWidth) < 1024);

    useEffect(() => {
        // Handle Resize
        const handleResize = () => {
            setIsMobileScreen(Math.min(window.innerWidth, window.outerWidth) < 1024);
        };

        window.addEventListener('resize', handleResize);
        window.addEventListener('pageshow', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('pageshow', handleResize);
        };
    }, []);

    return (
        <MobileScreenContext.Provider value={isMobileScreen}>
            {children}
        </MobileScreenContext.Provider>
    );
};